import {styled, theme, Button, Box} from "@reside/ui";
import Div100vh from "react-div-100vh";

import {hexToRgba} from "../../page-admin-organizations-branding/utils";
import {isHighContrastColor} from "../../../utils/helpers/isHighContrastColor";

// This is the file for styles that are shared between admission entry pages (welcome and verify answers)

// Shared layout for admission entry pages
export const Layout = styled(Div100vh)`
  overflow-y: auto;
  padding: ${theme.space[4]}px;

  // Add a gradient background to the page and a background image
  &::after {
    content: "";
    background: linear-gradient(
        ${hexToRgba(theme.color.primary, 0.5)},
        rgba(255, 255, 255, 0.5)
      ),
      url("/assets/getStartedBg.webp");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center top;
    opacity: 0.4;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: -1;
  }

  footer {
    position: absolute;
    bottom: ${theme.space[6]}px;
    left: ${theme.space[6]}px;
  }

  footer > button > i {
    color: ${({theme}) => {
      const primary = theme.color.primary;

      if (isHighContrastColor(primary)) {
        return theme.color.textPrimary;
      }

      return primary;
    }};

    border-color: ${({theme}) => {
      const primary = theme.color.primary;

      if (isHighContrastColor(primary)) {
        return theme.color.textPrimary;
      }

      return primary;
    }};
  }
`;

// Submit button for forms
export const SubmitButton = styled(Button)`
  display: block;
  width: 100%;
  margin-top: ${({theme}) => theme.space[5]}px;
  margin-bottom: ${({theme}) => theme.space[4]}px;

  border: 1px solid
    ${({theme}) => {
      const primary = theme.color.primary;

      if (isHighContrastColor(primary)) {
        return theme.color.textPrimary;
      }

      return primary;
    }};

  span {
    color: ${({theme}) => {
      const primary = theme.color.primary;

      if (isHighContrastColor(primary)) {
        return theme.color.textPrimary;
      }

      return theme.color.white;
    }} !important;
  }
`;

// Header container for logo and title
export const HeaderContainer = styled(Box)`
  text-align: center;
`;

// Form container styling
export const FormBoxWrapper = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 500px;
  margin: 16px auto;

  h3 {
    margin-top: 8px;
    margin-bottom: 16px;
  }

  @media (min-width: ${({theme}) => theme.breakpoint.md}px) {
    padding: 26px;
  }

  @media (min-width: ${({theme}) => theme.breakpoint.lg}px) {
    padding: 24px;

    h3 {
      margin-top: 16px;
      margin-bottom: 24px;
    }
  }
`;
